/* eslint-disable import/prefer-default-export */
/* eslint-disable no-useless-escape */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Button } from 'primereact/button';
import moment from 'moment';
import { diffChars, diffWords } from 'diff';

import PdfIcon from '../assets/icons/pdf-icon.svg';
import SvgIcon from '../assets/icons/svg-icon.svg';
import PngIcon from '../assets/icons/png-icon.svg';
import JpgIcon from '../assets/icons/jpg-icon.svg';
import JpegIcon from '../assets/icons/jpeg-icon.svg';
import DocIcon from '../assets/icons/doc-icon.svg';
import XlsIcon from '../assets/icons/xls-icon.svg';
import PptIcon from '../assets/icons/ppt-icon.svg';
import PptxIcon from '../assets/icons/pptx-icon.svg';
import XlsxIcon from '../assets/icons/xlsx-icon.svg';
import TxtIcon from '../assets/icons/txt-icon.svg';
import AiIcon from '../assets/icons/ai.svg';
import DocxIcon from '../assets/icons/docx-icon.svg';
import MP4Icon from '../assets/icons/mp4-icon.svg';
import MovIcon from '../assets/icons/mov-icon.svg';
import VlcIcon from '../assets/icons/vlc-icon.svg';
import WmvIcon from '../assets/icons/wmv-icon.svg';
import AviIcon from '../assets/icons/avi-icon.svg';
import MkvIcon from '../assets/icons/Mkv-icon.svg';
import WavIcon from '../assets/icons/wav-icon.svg';
import Mp3Icon from '../assets/icons/mp3-icon.svg';
import OggIcon from '../assets/icons/ogg-icon.svg';
import M4aIcon from '../assets/icons/m4a-icon.svg';
import AacIcon from '../assets/icons/aac-icon.svg';
import FlacIcon from '../assets/icons/flac-icon.svg';
import CsvIcon from '../assets/icons/csv-icon.svg';
import XmlIcon from '../assets/icons/xml-icon.svg';
import BmpIcon from '../assets/icons/bmp-icon.svg';
import RtfIcon from '../assets/icons/rtf-icon.svg';
import MsgIcon from '../assets/icons/msg-icon.svg';
import EmlIcon from '../assets/icons/eml-icon.svg';
import HtmlIcon from '../assets/icons/html-icon.svg';
import SortUpIcon from '../assets/icons/sort-up-icon.svg';
import SortDownIcon from '../assets/icons/sort-down-icon.svg';
import SortCommonIcon from '../assets/icons/sort-common-icon.svg';

export const cssClasses: any = {
  'cough-cold': 'bright-gray',
  'analgesics': 'lumber',
  'nutritionals-gi': 'light-yellow',
  'allergy': 'aero-blue',
  'derm': 'lavender',
  'default': 'default-folder'
};

export const normalizeCategoryKey = (category: string) => {
  return category
    .toLowerCase()
    .replace(/[\/&\s]+/g, '-')
    .replace(/-+/g, '-')
    .trim();
};

export const getCssClass = (category: string) => {
  const key = normalizeCategoryKey(category);
  return cssClasses[key] || cssClasses.default;
};

export const capitalizeWords = (str: string) => {
  return str?.split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const handleError = (error: any, toast: any) => {
  if ([401, 404, 500, 502, 504, 0].includes(error?.request?.status)) {
    const toastmsg: any = error?.response?.data?.message ? error?.response?.data?.message : 'Something is wrong. Please try after sometime.';
    toast?.current?.show({ severity: 'error', summary: 'Error', detail: toastmsg });
  }
};

export const formatRoleText = (role: string) => {
  return role
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getInitials = (name: any) => {
  const parts = name?.split(' ');
  const firstInitial = parts?.[0]?.[0]?.toUpperCase();
  const lastInitial = parts?.[parts.length - 1]?.[0]?.toUpperCase();
  return firstInitial + lastInitial;
};

/**
 * Returns role-based initials for an annotator.
 * Returns null when no role is provided (caller should fall back to name initials).
 */
export const getRoleInitials = (annotatorRole?: string, reviewerLabel?: string): string | null => {
  if (!annotatorRole) return null;
  if (annotatorRole === 'reviewer') return reviewerLabel?.charAt(0)?.toUpperCase() ?? null;
  if (annotatorRole === 'brand_owner') return 'PO';
  if (annotatorRole === 'admin' || annotatorRole === 'marcom') return 'MA';
  if (annotatorRole === 'agency') return 'A';
  return null;
};

export const formatDateRange = (range: any) => {
  const startDate = new Date(Date.UTC(
    new Date(range.startDate).getFullYear(),
    new Date(range.startDate).getMonth(),
    new Date(range.startDate).getDate(),
    0,
    0,
    0,
    0
  ));

  let endDate = null;
  if (range.endDate) {
    endDate = new Date(Date.UTC(
      new Date(range.endDate).getFullYear(),
      new Date(range.endDate).getMonth(),
      new Date(range.endDate).getDate(),
      23,
      59,
      59,
      999
    ));
  }
  const format = (date: Date) => date.toISOString().split('T')[0];
  return {
    start: format(startDate),
    end: endDate ? format(endDate) : null,
  };
};

export const renderMentionFormattedText = (data: any, mentions?: any, backgroundColor?: string, originalText: any = '') => {
  if (!data) return '';

  const mentionRegex = /\[@mention\((.*?)\)\]/g;
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const boldTextRegex = /\[\[(.*?)\]\]/g;
  const tempData = typeof data === 'string' ? data : data.text;

  let formattedText = tempData;

  if (originalText) {
    const diff = diffChars(originalText, formattedText);

    formattedText = diff
      .map((part) => {
        if (part.added) {
          return `<span style="color: #0cd70c; font-weight: 500;">${part.value}</span>`;
        }

        if (part.removed) {
          return `<span style="color: red; text-decoration: line-through;">${part.value}</span>`;
        }

        return part.value;
      })
      .join('');
  }

  formattedText = formattedText?.replace(mentionRegex, (match: any, key: any) => {
    let user;

    if (mentions && Object.keys(mentions).length > 0) {
      if (Array.isArray(mentions)) {
        user = mentions.find((u) => u.id === key || u.email === key);
      } else {
        user = mentions[key];
      }
    }

    if (user) {
      const fullName = `${user.first_name} ${user.last_name}`;
      return `<span class="user-mention-content" style="background-color: ${backgroundColor || '#e3f2fd'}; padding: 2px 4px; border-radius: 4px;">${fullName}</span>`;
    }

    return `<span class="user-mention-content" style="background-color: ${backgroundColor || '#e3f2fd'}; padding: 2px 4px; border-radius: 4px;">@${key}</span>`;
  });

  formattedText = formattedText?.replace(boldTextRegex, (match: any, text: any) => {
    return `<span style="font-weight: bold; font-size: 15px;">${text}</span>`;
  });

  formattedText = formattedText?.replace(urlRegex, (url: string) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" title="${url}" style="color: blue; text-decoration: underline;">Link</a>`;
  });
  if (typeof data !== 'string' && data.is_pinned_suggestion_comment) {
    const suggestionPrefix = 'Suggestion:';
    const rawText = typeof data === 'string' ? data : data.text;
    const afterPrefix = rawText?.startsWith(suggestionPrefix)
      ? rawText.slice(suggestionPrefix.length)
      : rawText;
    formattedText = `<strong>${suggestionPrefix}</strong>${afterPrefix}`;
  }

  if (typeof data !== 'string' && data.is_pinned_correction_comment) {
    const suggestionPrefix = 'Correction Remark:';
    const rawText = typeof data === 'string' ? data : data.text;
    const afterPrefix = rawText?.startsWith(suggestionPrefix)
      ? rawText.slice(suggestionPrefix.length)
      : rawText;
    formattedText = `<strong>${suggestionPrefix}</strong>${afterPrefix}`;
  }
  return formattedText;
};

export const renderLinkFormattedText = (text: string) => {
  if (!text) return null;

  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(urlRegex)) {
    const start = match.index ?? 0;

    if (start > lastIndex) {
      parts.push(text.slice(lastIndex, start));
    }

    const url = match[0];
    parts.push(
      <a
        key={`url-${start}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'blue', textDecoration: 'underline' }}
      >
        {url}
      </a>
    );

    lastIndex = start + url.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return <div>{parts}</div>;
};

export const extractFirstMentionedFullName = (data: any, mentions: any) => {
  const match = data?.match(/\[@mention\((.*?)\)\]/);
  if (match && mentions[match[1]]) {
    const user = mentions[match[1]];
    return `${user.first_name} ${user.last_name}`;
  }
  return null;
};

export const getfileIcon = (fileExtension: any) => {
  if (fileExtension === 'png') {
    return PngIcon;
  } else if (fileExtension === 'jpg') {
    return JpgIcon;
  } else if (fileExtension === 'jpeg') {
    return JpegIcon;
  } else if (fileExtension === 'bmp') {
    return BmpIcon;
  } else if (fileExtension === 'txt') {
    return TxtIcon;
  } else if (fileExtension === 'rtf') {
    return RtfIcon;
  } else if (fileExtension === 'html') {
    return HtmlIcon;
  } else if (fileExtension === 'pdf') {
    return PdfIcon;
  } else if (fileExtension === 'svg') {
    return SvgIcon;
  } else if (fileExtension === 'xls') {
    return XlsIcon;
  } else if (fileExtension === 'ppt') {
    return PptIcon;
  } else if (fileExtension === 'pptx') {
    return PptxIcon;
  } else if (fileExtension === 'xlsx') {
    return XlsxIcon;
  } else if (fileExtension === 'ai') {
    return AiIcon;
  } else if (fileExtension === 'docx') {
    return DocxIcon;
  } else if (fileExtension === 'mp4') {
    return MP4Icon;
  } else if (fileExtension === 'mov') {
    return MovIcon;
  } else if (fileExtension === 'vlc') {
    return VlcIcon;
  } else if (fileExtension === 'wmv') {
    return WmvIcon;
  } else if (fileExtension === 'avi') {
    return AviIcon;
  } else if (fileExtension === 'mkv') {
    return MkvIcon;
  } else if (fileExtension === 'mp3') {
    return Mp3Icon;
  } else if (fileExtension === 'ogg') {
    return OggIcon;
  } else if (fileExtension === 'wav') {
    return WavIcon;
  } else if (fileExtension === 'm4a') {
    return M4aIcon;
  } else if (fileExtension === 'aac') {
    return AacIcon;
  } else if (fileExtension === 'flac') {
    return FlacIcon;
  } else if (fileExtension === 'csv') {
    return CsvIcon;
  } else if (fileExtension === 'xml') {
    return XmlIcon;
  } else if (fileExtension === 'msg') {
    return MsgIcon;
  } else if (fileExtension === 'eml') {
    return EmlIcon;
  } else if (fileExtension === 'excel') {
    return XlsxIcon;
  } else if (fileExtension === 'img' || fileExtension === 'image') {
    return PngIcon;
  } else if (fileExtension === 'video') {
    return MP4Icon;
  } else if (fileExtension === 'audio') {
    return Mp3Icon;
  } else {
    return DocIcon;
  }
};

export const getMimeType = (filename: string): string => {
  const extension = filename.split('.').pop()?.toLowerCase() || '';

  const map: Record<string, string> = {
    mp4: 'video/mp4',
    avi: 'video/x-msvideo',
    mkv: 'video/x-matroska',
    mov: 'video/quicktime',
    webm: 'video/webm',
    mpeg: 'video/mpeg',
    mpg: 'video/mpeg',
    wmv: 'video/x-ms-wmv',
    flv: 'video/x-flv',
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
    aac: 'audio/aac',
    aiff: 'audio/aiff',
    flac: 'audio/flac',
    m4a: 'audio/mp4',
    ogg: 'audio/ogg'
  };

  return map[extension] || 'application/octet-stream';
};

export const base64ToBlobUrl = (base64: string, mimeType = 'application/octet-stream') => {
  const base64WithoutPrefix = base64.split(',').pop() || '';

  const byteCharacters = atob(base64WithoutPrefix);
  const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], { type: mimeType });

  return URL.createObjectURL(blob);
};

export const groupByFirstPermission = (users: any) => {
  const grouped = users.reduce((acc: any, userItem: any) => {
    const permission = userItem?.permissions[0];

    let group = acc.find((g: any) => g.roleName === permission);
    if (!group) {
      group = { roleName: permission, usergroup_list: [] };
      acc.push(group);
    }

    group.usergroup_list.push(userItem);
    return acc;
  }, []);

  return grouped;
};

export const formatDecimalNumber = (num: any, decimalNum: any) => {
  const parsed = typeof num === 'number' ? num : Number(num);
  if (!Number.isFinite(parsed)) return parsed;
  return Number.isInteger(parsed) ? parsed : parseFloat(parsed.toFixed(decimalNum));
};

export const secondsToMinutes = (seconds: number, decimalPlaces: number = 2) => {
  const minutes = seconds / 60;
  return formatDecimalNumber(minutes, decimalPlaces);
};

export const formatTime = (timeInSeconds: number): string => {
  if (!Number.isFinite(timeInSeconds) || timeInSeconds < 0) {
    return '0:00.00';
  }

  const totalMs = Math.round(timeInSeconds * 1000);

  const minutes = Math.floor(totalMs / 60000);
  const seconds = Math.floor((totalMs % 60000) / 1000);
  const centiseconds = Math.floor((totalMs % 1000) / 10);

  return `${minutes}:${seconds.toString().padStart(2, '0')}.${centiseconds
    .toString()
    .padStart(2, '0')}`;
};

export const getRelativeTime = (created_datetime: any) => {
  const now = moment();
  const created = moment(created_datetime);
  const diffMinutes = now.diff(created, 'minutes');
  const diffHours = now.diff(created, 'hours');
  const diffDays = now.diff(created, 'days');

  if (diffMinutes < 1) {
    return 'Just now';
  } else if (diffMinutes < 60) {
    return `${diffMinutes} min${diffMinutes === 1 ? '' : 's'} ago`;
  } else if (diffHours < 24) {
    return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
  } else {
    return `${diffDays} day${diffDays === 1 ? '' : 's'} ago`;
  }
};

export function formatISOToMMDDYYYY(isoString: any) {
  if (!isoString) return '';

  const datePart = isoString.split('T')[0];
  const [year, month, day] = datePart.split('-');

  return `${month}/${day}/${year}`;
}

export const customPaginatorTemplate = {
  layout: 'CurrentPageReport PrevPageLink PageLinks NextPageLink',
  CurrentPageReport: (options: any) => {
    return (
      <div className="flex-1 cus-pager-page-report">
        {options.first} - {options.last} of {options.totalRecords} items
      </div>
    );
  },
  PrevPageLink: (options: any) => {
    return (
      <Button
        className="border cus-prev-btn"
        onClick={options.onClick}
        disabled={options.disabled}
        label="Previous"
      />
    );
  },
  NextPageLink: (options: any) => {
    return (
      <Button
        className="border cus-nxt-btn"
        onClick={options.onClick}
        disabled={options.disabled}
        label="Next"
      />
    );
  },
  PageLinks: (options: any) => {
    const { page, currentPage, onClick, className, ariaLabel, ariaCurrent } = options;

    const isActive = currentPage === page;

    return (
      <Button
        key={page}
        onClick={(e) => onClick(e, page)}
        className={`m-0 border ${isActive ? 'cus-active-page cus-pages' : 'cus-pages'
        }`}
        aria-label={ariaLabel}
        aria-current={ariaCurrent}
      >
        {page + 1}
      </Button>
    );
  }
};

export const customTableSortIcon = ({ sortOrder }: any) => {
  if (sortOrder === 1) return <img src={SortUpIcon} alt="up" style={{ marginLeft: '10px' }} />;
  if (sortOrder === -1) return <img src={SortDownIcon} alt="up" style={{ marginLeft: '10px' }} />;
  return <img src={SortCommonIcon} alt="up" style={{ marginLeft: '10px', width: '17px' }} />;
};

export const getStatusInfo = (status: string, createdBy: string) => {
  let iconInfo: any;

  switch (status) {
    case 'new':
      if (createdBy !== 'agency') {
        iconInfo = { statusText: 'Pending Upload' };
      } else { iconInfo = { statusText: 'New' }; }
      break;
    case 'materials_uploaded':
      iconInfo = { statusText: 'Materials Uploaded' };
      break;
    case 'asset_upload':
      iconInfo = { statusText: 'Asset Uploaded' };
      break;
    case 'in_review':
      iconInfo = { statusText: 'In Review' };
      break;
    case 'ready_for_meeting':
      iconInfo = { statusText: 'Ready for Meeting' };
      break;
    case 'ready_for_review':
      iconInfo = { statusText: 'Ready for Review' };
      break;
    case 'approved':
      iconInfo = { statusText: 'Approved' };
      break;
    case 'approved_with_changes':
      iconInfo = { statusText: 'Approved with Changes' };
      break;
    case 'needs_revision':
      iconInfo = { statusText: 'Needs Revision' };
      break;
    case 'sent_for_revision':
      iconInfo = { statusText: 'Sent for Revision' };
      break;
    case 'needs_review':
      iconInfo = { statusText: 'Start Review' };
      break;
    case 'cancelled':
      iconInfo = { statusText: 'Cancelled' };
      break;
    case 'complete':
      iconInfo = { statusText: 'Complete' };
      break;
    case 'completed':
      iconInfo = { statusText: 'Complete' };
      break;
    case 'final_asset_uploaded':
      iconInfo = { statusText: 'Complete: Final Asset Uploaded' };
      break;
    case 'asset_uploaded':
      iconInfo = { statusText: 'Asset Uploaded' };
      break;
    case 'sent_for_approval':
      iconInfo = { statusText: 'Sent for Approval' };
      break;
    case 'revise_and_resubmit':
      iconInfo = { statusText: 'Revise & Resubmit' };
      break;
    case 'in_discussion':
      iconInfo = { statusText: 'Needs Meeting' };
      break;
    case 'discuss':
      iconInfo = { statusText: 'Discuss' };
      break;
    case 'accept':
      iconInfo = { statusText: 'Accepted' };
      break;
    case 'ignore':
      iconInfo = { statusText: 'Ignore' };
      break;
    case 'stet':
      iconInfo = { statusText: 'STET' };
      break;
    case 'deleted':
      iconInfo = { statusText: 'Deleted' };
      break;
    case 'ai_action_accept':
      iconInfo = { statusText: 'Added' };
      break;
    case 'ai_action_ignore':
      iconInfo = { statusText: 'Ignored' };
      break;
    case 'ai_study_completed':
      iconInfo = { statusText: 'Completed' };
      break;
    case 'ai_study_job_in_queue':
      iconInfo = { statusText: 'Job in Queue' };
      break;
    case 'ai_study_processing':
      iconInfo = { statusText: 'Processing' };
      break;
    case 'ai_study_failed':
      iconInfo = { statusText: 'Failed' };
      break;
    case 'draft_pending_approval':
      iconInfo = { statusText: 'PO Review' };
      break;
    default:
      iconInfo = { statusText: status };
  }

  return iconInfo;
};
